import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  IconButton,
  Pagination,
  Grid,
  Button,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import instance from "../Axios/axiosConfig";
import BuyModal from "../components/BuyModal/BuyModal";

const LivePage = () => {
  const [posts, setPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [status, setStatus] = useState("live");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const itemsPerPage = 12;

  const fetchPosts = async (title = "", page = 0, status = "live") => {
    setIsLoading(true);
    const isLive = status === "live";
    try {
      const response = await instance.post(
        "/publish/search",
        { page, limit: itemsPerPage, title, isLive },
        { headers: { "Content-Type": "application/json" } }
      );
      setPosts(response.data.posts || []);
      setTotalPages(response.data.totalPages || 1);
    } catch (error) {
      console.error("Failed to fetch posts:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts(searchTerm, currentPage - 1, status);
  }, [searchTerm, currentPage, status]);

  const handleBuyClick = (post) => {
    setSelectedPost(post);
    setOpenModal(true);
  };

  return (
    <Box sx={{ width: { xs: "95%", sm: "90%", md: "80%" }, mx: "auto", mt: 4 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Search posts"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              label="Status"
              onChange={(e) => setStatus(e.target.value)}
            >
              <MenuItem value="live">Live</MenuItem>
              <MenuItem value="pending">Pending</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {isLoading ? (
        <Typography align="center" mt={4}>
          Loading...
        </Typography>
      ) : (
        <TableContainer component={Paper} sx={{ mt: 4 }}>
          <Table>
            <TableHead>
              <TableRow>
                {status === "live" ? (
                  <>
                    <TableCell sx={{ fontWeight: "bold" }}>Title</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Visits</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Likes</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="center">
                      View
                    </TableCell>
                  </>
                ) : (
                  <>
                    <TableCell sx={{ fontWeight: "bold" }}>Title</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Go Live</TableCell>
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {posts.map((post) => (
                <TableRow key={post._id}>
                  <TableCell>{post.title || "Untitled"}</TableCell>
                  {status === "live" ? (
                    <>
                      <TableCell>{post.visits || 0}</TableCell>
                      <TableCell>{post.likes || 0}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          href={`https://justpasteit.in/publish/${post.uniqueId}.html`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <OpenInNewIcon />
                        </IconButton>
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell>
                        <Typography color="warning.main">Pending</Typography>
                      </TableCell>
                      <TableCell>
                        {post.isPremium ? (
                          <Typography color="green" fontWeight="bold">
                            In Progress
                          </Typography>
                        ) : (
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => handleBuyClick(post)}
                          >
                            Buy
                          </Button>
                        )}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
              {posts.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No posts found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <Pagination
          size="small"
          count={totalPages}
          page={currentPage}
          onChange={(_, page) => setCurrentPage(page)}
          variant="outlined"
          color="secondary"
          shape="rounded"
          siblingCount={0}
        />
      </Box>

      <BuyModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        post={selectedPost}
      />
    </Box>
  );
};

export default LivePage;
